import React, { Component, createRef, Fragment } from "react";
import "component/details/InfoAction/styles.scss";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import { getTotalPool } from "utils/getTotalpool";
import ShowMoreText from "react-show-more-text";
import { HAN_REGEX } from "utils/constants";
import { currencyFormatter } from "utils/currencyHelper";
import { renderWithBoldHelper } from "utils/renderWithBoldHelper";
import { setDefaultImageFormat } from "utils/image";
import bannerDefault from "assets/images/bannerDefault.png";
import { ReactComponent as Play } from "assets/icons/Play-Launch.svg";
import { ReactComponent as PlayDemo } from "assets/icons/play-demo.svg";

import { isEmpty, isEqual } from "lodash";
import { withNamespaces } from "react-i18next";
import * as queryString from "query-string";

class InfoAction extends Component {
  constructor(props) {
    super(props);
    this.topPosition = createRef();
    this.descriptionContainerRef = createRef();
    this.imgDefaultRef = createRef();
    this.resizeObserver = null;
    this._resizeRaf = null;

    this.onClickName = this._onClickName.bind(this);
    this.handleDescription = this._handleDescription.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.renderInfoRows = this._renderInfoRows.bind(this);
    this.setupResizeObserver = this._setupResizeObserver.bind(this);

    this.state = {
      hasDescription:
        props.details && !isEmpty(props.details.get("description")),
      activeDetails: false,
      expandDescription: false,
      jackpotPool: null,
      imageLoaded: false,
      containerWidth: 0,
    };
  }

  componentDidMount() {
    if (!this.props.isMobile) this.setState({ activeDetails: true });
    this.setupResizeObserver();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.details, prevProps.details)) {
      this.setState({
        imageLoaded: false,
      });
    }

    if (
      !prevProps.details &&
      this.props.details &&
      this.descriptionContainerRef.current &&
      !this.resizeObserver
    ) {
      this.setupResizeObserver();
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
    if (this._resizeRaf) {
      cancelAnimationFrame(this._resizeRaf);
      this._resizeRaf = null;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.details &&
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.details.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.props.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  _setupResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    if (!this.descriptionContainerRef.current) return;
    if (this.resizeObserver) return;

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width = Math.round(entry.contentRect.width);
        if (width > 0 && width !== this.state.containerWidth) {
          if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
          this._resizeRaf = requestAnimationFrame(() => {
            this.setState({ containerWidth: width });
          });
        }
      }
    });
    this.resizeObserver.observe(this.descriptionContainerRef.current);
  }

  _onClickName() {
    this.setState({ activeDetails: !this.state.activeDetails });
  }

  _handleDescription() {
    let btns = document.getElementsByClassName(
      `description-clickable ${this.props.gameIndex}`,
    );
    if (btns.length > 1) {
      if (this.state.expandDescription) {
        btns[0].click();
      } else {
        btns[1].click();
      }
      this.setState({ expandDescription: !this.state.expandDescription });
      if (this.props.handleDescription) {
        this.props.handleDescription();
      }
    }
  }

  _getGameIconUrl() {
    if (!this.props.details) return "";
    const imgUrl = this.props.details.getIn(["images", "logoSquareUrl"]);
    if (!imgUrl) return "";
    const urlObj = queryString.parseUrl(imgUrl);
    urlObj.query.width = 56;
    urlObj.query.theme = "dark";
    return `${urlObj.url}?${queryString.stringify(urlObj.query)}`;
  }

  _renderInfoRows() {
    const { t, details } = this.props;

    if (!details) {
      const dummyRows = [
        { label: t("type"), text: "XXXXXX XX XXXX" },
        { label: t("limits"), text: "XXX XX XXXXX" },
        { label: t("features"), text: "XXX XX XXXXX" },
      ];
      return dummyRows.map((row, idx) => (
        <tr className="trinfo" key={`dummy-${idx}`}>
          <th>{row.label}: </th>
          <td>
            <span className="dummy">{row.text}</span>
          </td>
        </tr>
      ));
    }

    const rows = [];

    if (details.get("gameType")) {
      rows.push(
        <tr className="trinfo" key="type">
          <th data-testid="type-label">{t("type")}: </th>
          <td data-testid="type-value">{details.get("gameType")}</td>
        </tr>,
      );
    }

    if (details.get("gameLimit") && details.get("gameLimit").get('minBet')) {
      rows.push(
        <tr className="trinfo" key="limits">
          <th data-testid="limits-label">{t("limits")}: </th>
          <td data-testid="limits-value">
            <span className="min-bet">
              {currencyFormatter(details.get("gameLimit").get("minBet"), {
                currency: this.props.currency,
                dropZeroDecimals: true,
              })}
            </span>
            <span className="max-bet">
              {` - ${currencyFormatter(
                details.get("gameLimit").get("maxBet"),
                {
                  dropZeroDecimals: true,
                },
              )}`}
            </span>
          </td>
        </tr>,
      );
    }
    if (details.get("gameLimit") && 
      details.get("gameLimit").get('maxWinBetMultiplier')) {
      rows.push(
        <tr className="trinfo" key="maxWin">
          <th>{t("maxWin")}: </th>
          <td>
            <span>
              {currencyFormatter(details.get("gameLimit").get('maxWinBetMultiplier'), {
                dropZeroDecimals: true,
              })}x
            </span>
          </td>
        </tr>,
      );
    }    

    if (details.get("specialFeatures")) {
      rows.push(
        <tr className="trinfo" key="features">
          <th data-testid="features-label">{t("features")}: </th>
          <td data-testid="features-value">
            <span>{details.get("specialFeatures").join(", ")}</span>
          </td>
        </tr>,
      );
    }

    if (details.get("themes")) {
      rows.push(
        <tr className="trinfo" key="themes">
          <th data-testid="themes-label">{t("themes")}: </th>
          <td data-testid="themes-value">
            <span>{details.get("themes").join(", ")}</span>
          </td>
        </tr>,
      );
    }

    if (details.get("volatility")) {
      rows.push(
        <tr className="trinfo" key="variance">
          <th data-testid="variances-label">{t("variance")}: </th>
          <td data-testid="variances-value">
            <span>{details.get("volatility")}</span>
          </td>
        </tr>,
      );
    }

    if (details.get("releaseDate")) {
      rows.push(
        <tr className="trinfo" key="released">
          <th data-testid="released-label">{t("released")}: </th>
          <td data-testid="released-value">
            <span>{details.get("releaseDate")}</span>
          </td>
        </tr>,
      );
    }

    return rows;
  }

  render() {
    const { t, details } = this.props;

    return (
      <div
        className={`info-action-component ${this.props.className || ""} ${
          this.props.compact ? "compact" : ""
        }`}
      >
        <div className="image-row-expand">
          {this.props.details && (
            <img
              className={`img-fluid w-100 ${
                this.state.imageLoaded ? "" : "d-none"
              }`}
              src={`${setDefaultImageFormat(
                this.props.details.getIn(["images", "bannerUrl"]) +
                  "width=450&theme=dark",
                this.props.imageFormat.get("banner"),
              )}`}
              alt={this.props.details.get("name")}
              onLoad={(event) => {
                this.setState({
                  imageLoaded: true,
                });
              }}
            />
          )}
          {!this.state.imageLoaded && (
            <img
              className="img-fluid w-100"
              src={bannerDefault}
              alt="default"
            />
          )}
          {details &&
            details.get("gameLimit") &&
            details.get("gameLimit").get('minBet') && (
              <div className="game-limits" data-testid="game-limits">
                <span className="min-bet">
                  {currencyFormatter(details.get("gameLimit").get("minBet"), {
                    symbol: this.props.symbol,
                    currency: this.props.currency,
                    dropZeroDecimals: true,
                  })}
                </span>
                <span className="max-bet">
                  {` - ${currencyFormatter(
                    details.get("gameLimit").get("maxBet"),
                    {
                      dropZeroDecimals: true,
                    },
                  )}`}
                </span>
              </div>
            )}
        </div>
        <div className="row nopadding">
          <div className="col-auto nopadding game-icon-container">
            {this.props.details && this.props.isGameView && (
              <img
                className={`img-fluid`}
                data-testid="game-icon"
                src={this._getGameIconUrl()}
                alt={this.props.details.get("name")}
              />
            )}
          </div>
          <div className="col">
            <div className="info">
              <div className="title">
                {!this.props.details && (
                  <span className="dummy">XXXX XXXXXX</span>
                )}

                {this.props.details && this.props.details.get("name") && (
                  <Fragment>
                    <span data-testid="game-title">{this.props.details.get("name")}</span>
                  </Fragment>
                )}
              </div>
              <div className="provider">
                {!this.props.details && <span className="dummy">XXXXXXXX</span>}
                {this.props.details && this.props.details.get("provider") && (
                  <span data-testid="game-provider-name">{this.props.details.get("provider")}</span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row nopadding">
          <div className="col">
            <div className="info">
              <div className="provider jackpot-pool">
                {!this.props.details && (
                  <span className="dummy">XXXXXXXX</span>
                )}
                {this.props.details && this.props.details.get("tournament") && (
                  <span className="game-feature-badge jackpotIcon" data-testid="daily-reward-badge">
                    <TrophyIcon color="rgba(255, 204, 0, 1)" />
                    {this.props.details.getIn(["tournament", "name"])}
                  </span>
                )}
                {this.props.details && this.props.details.get("jackpot") && (
                  <span className="game-feature-badge jackpotIcon">
                    <CrownIcon color="rgba(255, 204, 0, 1)" />
                    {this.props.details.getIn(["jackpot", "name"])}
                  </span>
                )}
                {this.props.details &&
                  this.props.details.get("totalFreePlayAmount") && (
                    <span className="game-feature-badge ribbonIcon" data-testid="free-play-text">
                      <RibbonIcon color="rgba(255, 204, 0, 1)" />
                      {renderWithBoldHelper(
                        t,
                        "enjoyInFreePlay",
                        "amount",
                        currencyFormatter(
                          this.props.details.get("totalFreePlayAmount"),
                          { currency: this.props.currency },
                        ),
                      )}
                    </span>
                  )}
                {this.props.details && this.props.details.get("isFeatured") && (
                  <span className="game-feature-badge editorsChoiceIcon" data-testid="editors-choice-badge">
                    <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                    {t("editorsChoice")}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row nopadding button-container">
          <div className="col">
            {this.props.isLoading && (
              <div className="btn btn-secondary w-100 dummy">&nbsp;</div>
            )}
            {!this.props.isLoading &&
              this.props.details &&
              this.props.realLink && (
                <button
                  className={`btn btn-danger w-100 ${
                    this.props.loadingGameRel === "launch.real" ? "animate" : ""
                  }`}
                  data-testid="play-now-button"
                  onClick={() => {
                    this.setState({
                      loadingGameRel: this.props.realLink.get("rel"),
                    });
                    switch (this.props.gameLaunchTarget) {
                      case "_top":
                      case "_self":
                      case "_parent":
                        let rel = this.props.realLink.get("rel");
                        this.props.onGameItemClickHandler(rel);
                        break;
                      default:
                        this.props.onClickEventHandler(this.props.realLink);
                        break;
                    }
                  }}
                  disabled={this.props.loadingGameRel !== null}
                >
                  <span className="play-now-icon">
                    <Play />
                  </span>
                  &nbsp;
                  <span data-testid="play-now-label">
                    {this.props.playLabel ? this.props.playLabel : t("playNow")}
                  </span>
                </button>
              )}

            {this.props.isLoading && (
              <div className="btn btn-secondary w-100 dummy">&nbsp;</div>
            )}

            {!this.props.isLoading &&
              this.props.details &&
              this.props.demoLink && (
                <button
                  className={`btn btn-secondary w-100 ${
                    this.props.loadingGameRel === "launch.demo" ? "animate" : ""
                  }`}
                  data-testid="demo-play-button"
                  onClick={() => {
                    this.setState({
                      loadingGameRel: this.props.demoLink.get("rel"),
                    });
                    switch (this.props.gameLaunchTarget) {
                      case "_top":
                      case "_self":
                      case "_parent":
                        let rel = this.props.demoLink.get("rel");
                        this.props.onGameItemClickHandler(rel);
                        break;
                      default:
                        this.props.onClickEventHandler(this.props.demoLink);
                        break;
                    }
                  }}
                  disabled={this.props.loadingGameRel !== null}
                >
                  <span className="play-now-icon">
                    <PlayDemo />
                  </span>
                  &nbsp;<span data-testid="demo-play-label">{t("demoPlay")}</span>
                </button>
              )}
            {!this.props.isLoading &&
              this.props.details &&
              !this.props.realLink &&
              !this.props.demoLink && (
                <div className="no-gameplay">{t("noAvailableGameplay")}</div>
              )}
          </div>
        </div>
        {!this.props.details && (
          <div className="row nopadding">
            <div className="col">
              <div className="description">
                <span className="dummy">
                  XXXXXX XX XXXX XXXX XX XXXXXXX XXX XXXXXXX XXXXXXX
                </span>
              </div>
            </div>
          </div>
        )}
        {this.props.details && this.props.details.get("description") && (
          <div className="row nopadding">
            <div className="col">
              <div
                className="description"
                data-testid="game-description"
                ref={this.descriptionContainerRef}
              >
                <div
                  onClick={() => {
                    this.handleDescription();
                  }}
                >
                  {this.props.details.get("description").match(HAN_REGEX) ? (
                    <>
                      <span className="description-sub">
                        {this.props.details.get("description").substring(0, 65)}
                      </span>
                      <ShowMoreText
                        lines={3}
                        more={t("more")}
                        less=""
                        width={this.state.containerWidth}
                        className="description-span"
                        anchorClass={`description-clickable ${
                          this.props.gameIndex
                        }`}
                        onClick={this.executeOnClick}
                        expanded={this.state.expandDescription ? true : false}
                        truncatedEndingComponent={"... "}
                      >
                        {this.props.details.get("description").substring(65)}
                      </ShowMoreText>
                    </>
                  ) : (
                    <ShowMoreText
                      lines={3}
                      more={t("more")}
                      less=""
                      width={this.state.containerWidth}
                      className="description-span"
                      anchorClass={`description-clickable ${
                        this.props.gameIndex
                      }`}
                      onClick={this.executeOnClick}
                      expanded={this.props.expandDescription ? true : false}
                      truncatedEndingComponent={"... "}
                    >
                      {this.props.details.get("description")}
                    </ShowMoreText>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row nopadding">
          <div className="col">
            <table className={`tinfo`}>
              <tbody>{this.renderInfoRows()}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces("translation")(InfoAction);
